import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URLS } from '../config/api.urls';

@Injectable({
    providedIn: 'root'
})
export class CountryService {

    constructor(private httpClient: HttpClient) { }

    getCountries(): Observable<any[]> {
        return this.httpClient.get<any[]>(API_URLS.LIST_OF_COUNTRIES);
    }
}
